import React from 'react';
import parse from 'html-react-parser';

export default function BannerSectionStyle5({
  bgUrl,
  imgUrl,
  title,
  subTitle,
}) {
  return (
    <section className="relative md:min-h-[520px] flex items-center pt-[116px] pb-14 md:pt-[100px] md:pb-[80px] overflow-hidden bg-cream border-b border-[rgba(139,26,26,0.08)]">
      {/* Subtle background pattern */}
      {bgUrl && (
        <div
          className="absolute inset-0 opacity-[0.04] bg-cover bg-center"
          style={{ backgroundImage: `url(${bgUrl})` }}
        />
      )}

      {/* Decorative left accent line */}
      <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-gradient-to-b from-transparent via-crimson to-transparent opacity-30" />

      <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-16 w-full grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

        {/* Text column (left) */}
        <div className="flex flex-col justify-center">
          <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-4 md:mb-5">
            <span className="w-[30px] h-px bg-gold block" />
            Noohra Integrated Services
          </div>

          <h1 className="font-serif text-[2.25rem] md:text-5xl lg:text-[3.5rem] font-light leading-[1.15] text-charcoal mb-4 md:mb-6">
            {parse(title || '')}
          </h1>

          {subTitle && (
            <p className="text-base leading-[1.8] text-mid font-light max-w-[480px] mb-0">
              {parse(subTitle)}
            </p>
          )}
        </div>

        {/* Image column (right) */}
        {imgUrl && (
          <div className="hidden md:flex items-end justify-center">
            <img
              src={imgUrl}
              alt="Page banner"
              className="max-h-[380px] w-auto object-contain drop-shadow-xl"
            />
          </div>
        )}
      </div>
    </section>
  );
}
